/**
 * Reads a GDPR error key from the usual response envelope.
 *
 * @param {unknown} error
 * @returns {string|null}
 */
export const getPositiveListErrorKey = (error) => {
    const data = error?.response?.data;
    const errorKey = data?.error
        || data?.message?.error
        || (typeof data?.message === "string" ? data.message : null);

    return typeof errorKey === "string" && errorKey.trim()
        ? errorKey.trim()
        : null;
};
